import { OrganizationForm } from '../OrganizationForm';

export const OrganizationCreate: React.FC = () => <OrganizationForm />;
